export interface RateYears {
  value: number;
  label: string;
}

export type RateYearsGetResponse = RateYears[];

export const EmptyRateYearsGetResponse: RateYearsGetResponse = [
  {
    value: 0,
    label: '',
  },
];
